<template>
	<div>
		<template v-if="!show_detail">
			<wrapper-mobile-view :space="90" :z_index="1045">
				<div class="px-4">
					<div class="p-4 bg-white radius-12">
						<div class="w-100 text-center">
							<i class="simple-icon-close text-orange text-40 mb-4 d-block"></i>
							<p class="heading-6-1 mb-0">Confirm Cancellation</p>
							<p class="body-2-2-1 mb-4">We apologize for the inconvenience, but we will cancel the reservation for the following reasons</p>
							<div class="w-100 p-3 bg-light-page border-semi-grey radius-6 mb-4">
								<p class="mb-0 body-2-1">{{reason}}</p>
							</div>
							<p class="body-2-2-1 mb-4 pb-4 border-b-semi-grey">We hope you understand this inconvenience. Do you agree to cancel this reservation?</p>
							<div class="row">
								<div class="col-6">
									<state-button :click="reject" variant="secondary" :block="true">
										Reject Cancellation
									</state-button>
								</div>
								<div class="col-6">
									<state-button :click="accept" variant="primary" :block="true">
										Cancel Reservation
									</state-button>
								</div>
								<div class="col-12">
									<div class="w-100 my-4 border-b-semi-grey"></div>
								</div>
								<div class="col-12">
									<button
										type="button"
										class="g-btn g-btn-secondary-outline w-100 g-btn-sm"
										@click="toggleDetail()">Detail Reservation</button>
								</div>
							</div>
						</div>
					</div>
				</div>
			</wrapper-mobile-view>
			<div class="w-100 z-index-1042" style="height: 100vh;background-color: #00000099;position: fixed;top:0;left:0px;right:0px;">
			</div>
		</template>

		<popup-detail
			id_ref="detail_trxx"
    	direction="bottom"
    	:show="show_detail"
    	use_max_size
    	wrapper_size="mobile"
    	@close="toggleDetail">
    	<template v-slot:body>
	    	<div class="p-4 text-left">
	    		<div class="row mb-3 pb-3 border-b-semi-grey">
      			<div class="col-10 align-self-center">
      				<p class="mb-0 body-1-4">Detail Booking</p>
      			</div>
      			<div class="col-2 text-right align-self-center">
      				<div class="bg-white rounded-circle border-semi-grey cursor-pointer" style="display:inline-flex;padding:10px;" @click="toggleDetail()">
								<img src="../../../assets/img/icon/close.png" width="14" />
							</div>
      			</div>
      		</div>

	        <div>
	        	<!-- Orders Details -->
	          <p class="mt-4 mb-2 body-2-2 text-16 font-bold">{{$t("hotel.order-details")}}</p>
	          <div class="row">
	          	<div class="col-12 mb-2">
	              <p class="mb-0 body-2 font-regular text-12">{{$t("hotel.rooms")}}</p>
	              <template v-for="room in tx.transaction_details">
	              	<p class="mb-0 body-2-2 text-14 font-semibold">{{room.name}} x {{room.qty}}
	              		<span v-if="room.qty > 1">{{$t("hotel.rooms")}}</span>
	              		<span v-else>{{$t("hotel.room")}}</span>
	              	</p>
	              </template>
	            </div>
	          	<div class="col-12 mb-2">
	              <p class="mb-0 body-2 font-regular text-12">{{$t("hotel.guests.guests")}}</p>
	              <p class="mb-0 body-2-2 text-14 font-semibold">{{tx.transaction_details[0].adult}} <span v-if="tx.transaction_details[0].adult > 1">{{$t("hotel.adults.adults")}}</span><span v-else>{{$t("hotel.adults.adult")}}</span><span v-if="tx.transaction_details[0].child != 0">, {{tx.transaction_details[0].child}} {{$t("hotel.children.children")}}</span><span v-if="tx.transaction_details[0].infant != 0">, {{tx.transaction_details[0].infant}} {{$t("hotel.infants.infants")}}</span>
	              	</p>
	            </div>
	            <div class="col-6 mb-2">
	              <p class="mb-0 body-2 font-regular text-12">{{$t("hotel.date.check-in")}}</p>
	              <p class="mb-0 body-2-2 text-14 font-semibold">{{$formatDate(tx.transaction_details[0].check_in_date)}}</p>
	            </div>
	            <div class="col-6 mb-2">
	              <p class="mb-0 body-2 font-regular text-12">{{$t("hotel.date.check-out")}}</p>
	              <p class="mb-0 body-2-2 text-14 font-semibold">{{$formatDate(tx.transaction_details[0].check_out_date)}}</p>
	            </div>
	          </div>
	          <!-- Contact Detail -->
	          <template v-if="tx.customer_details.first_name != tx.visitor_details.first_name && tx.customer_details.email != tx.visitor_details.email">
	            <p class="mt-4 mb-2 body-2-2 text-16 font-bold">{{$t("hotel.contact-detail.title")}}</p>
	            <div class="row">
	              <div class="col-12 mb-2">
	                <p class="mb-0 body-2 font-regular text-12">{{$t("ticket-cart.name")}} :</p>
	                <p class="mb-0 body-2-2 text-14 font-semibold">{{tx.customer_details.title}} {{tx.customer_details.first_name}} {{tx.customer_details.last_name}}</p>
	              </div>
	              <div class="col-6 mb-2">
	                <p class="mb-0 body-2 font-regular text-12">{{$t("hotel.visitor-detail.phone-number")}} :</p>
	                <p class="mb-0 body-2-2 text-14 font-semibold">{{tx.customer_details.phone_number}}</p>
	              </div>
	              <div class="col-6 mb-2">
	                <p class="mb-0 body-2 font-regular text-12">{{$t("hotel.visitor-detail.email")}} :</p>
	                <p class="mb-0 body-2-2 text-14 font-semibold text-truncate">{{tx.customer_details.email}}</p>
	              </div>
	              <div class="col-6 mb-2">
	                <p class="mb-0 body-2 font-regular text-12">{{$t("hotel.visitor-detail.address")}} :</p>
	                <p class="mb-0 body-2-2 text-14 font-semibold">{{tx.customer_details.address}}</p>
	              </div>
	              <div class="col-6 mb-2">
	                <p class="mb-0 body-2 font-regular text-12">{{$t("hotel.visitor-detail.country")}} :</p>
	                <p class="mb-0 body-2-2 text-14 font-semibold">{{tx.customer_details.country}}</p>
	              </div>
	            </div>
	          </template>
	          <!-- Visitor Detail -->
	          <template v-if="is_valid_visitor">
	            <p class="mt-4 mb-2 body-2-2 text-16 font-bold" v-if="is_valid_visitor">{{$t("hotel.visitor-detail.visitor-detail")}}</p>
	            <div class="row">
	              <div class="col-12 mb-2">
	                <p class="mb-0 body-2 font-regular text-12" v-if="tx.visitor_details.first_name != ''">{{$t("ticket-cart.name")}} :</p>
	                <p class="mb-0 body-2-2 text-14 font-semibold" v-if="tx.visitor_details.first_name != ''">{{tx.visitor_details.title}} {{tx.visitor_details.first_name}} {{tx.visitor_details.last_name}}</p>
	              </div>
	              <div class="col-6 mb-2" v-if="tx.visitor_details.phone_number != ''">
	                <p class="mb-0 body-2 font-regular text-12">{{$t("hotel.visitor-detail.phone-number")}} :</p>
	                <p class="mb-0 body-2-2 text-14 font-semibold">{{tx.visitor_details.phone_number}}</p>
	              </div>
	              <div class="col-6 mb-2" v-if="tx.visitor_details.email != ''">
	                <p class="mb-0 body-2 font-regular text-12">{{$t("hotel.visitor-detail.email")}} :</p>
	                <p class="mb-0 body-2-2 text-14 font-semibold text-truncate">{{tx.visitor_details.email}}</p>
	              </div>
	              <div class="col-6 mb-2" v-if="tx.visitor_details.address != ''">
	                <p class="mb-0 body-2 font-regular text-12">{{$t("hotel.visitor-detail.address")}} :</p>
	                <p class="mb-0 body-2-2 text-14 font-semibold">{{tx.visitor_details.address}}</p>
	              </div>
	              <div class="col-6 mb-2" v-if="tx.visitor_details.country != ''">
	                <p class="mb-0 body-2 font-regular text-12">{{$t("hotel.visitor-detail.country")}} :</p>
	                <p class="mb-0 body-2-2 text-14 font-semibold">{{tx.visitor_details.country}}</p>
	              </div>
	            </div>
	          </template>
	          <!-- Special Request -->
	          <p class="mt-4 mb-2 body-2-2 text-16 font-bold" v-if="tx.special_request_details.length > 0 || tx.custom_check_in_time != '' || tx.custom_check_out_time != ''">{{$t("hotel.special-request.title")}}</p>
	          <div class="row">
	            <div class="col-12 mb-2" v-if="tx.special_request_details.length > 0">
	              <div class="row">
	                <div class="col-6" :class="{'col-12':tx.special_request_details.length == 1}" v-for="special_request in tx.special_request_details">
	                  <img src="../../../assets/img/icon/correct.png" class="position-relative d-inline-block align-top" width="10" style="top: 4px;">
	                  <p class="mb-0 body-2-2 text-12 font-semibold d-inline-block w-75 align-top">{{special_request.name}} <span v-if="special_request.notes != ''">({{special_request.notes}})</span></p>
	                </div>
	              </div>
	            </div>
	            <div class="col-6 mb-2" v-if="tx.custom_check_in_time != ''">
	              <p class="mb-0 body-2 font-regular text-12">{{$t("hotel.special-request.request-check-in")}}</p>
	              <p class="mb-0 body-2-2 text-14 font-semibold d-inline-block w-75">{{tx.custom_check_in_time}}</p>
	            </div>
	            <div class="col-6 mb-2" v-if="tx.custom_check_out_time != ''">
	              <p class="mb-0 body-2 font-regular text-12">{{$t("hotel.special-request.request-check-out")}}</p>
	              <p class="mb-0 body-2-2 text-14 font-semibold d-inline-block w-75">{{tx.custom_check_out_time}}</p>
	            </div>
	            <div class="col-12 mb-2" v-if="tx.notes != ''">
	              <p class="mb-0 body-2 font-regular text-12">{{$t("hotel.special-request.other-request")}}</p>
	              <p class="mb-0 body-2-2 text-14 font-semibold d-inline-block ">{{tx.notes}}</p>
	            </div>
	          </div>
	          <!-- Additional Service -->
	          <template v-if="tx.additional_service_details.length > 0">
	          	<p class="mt-4 mb-2 body-2-2 text-16 font-bold">{{$t("hotel.additional-service")}}</p>
	            <div class="row slim-grid-row mb-2" v-for="additional in tx.additional_service_details">
	              <!-- <div class="col-3 col-mb-2 mb-2">
	                <img :src="additional." height="65" class="object-fit w-100 rounded-3">
	              </div> -->
	              <div class="col-12 col-mb-12">
	                <p class="mb-0 body-2-2 text-14 font-semibold">{{additional.name}}</p>
	                <p class="mb-0 body-2-2 text-14 font-regular">{{$formatCurrency(additional.price)}} / {{additional.unit}}</p>
	                <p class="mb-0 body-2-2 text-14 font-regular">{{additional.qty}}x</p>
	              </div>
	            </div>
	          </template>
	          <!-- Price Detail -->
	          <p class="mt-4 mb-2 body-2-2 text-16 font-bold">{{$t("hotel.payment-method.payment-detail")}}</p>
	          <div class="row">
	          	<template v-if="tx.payment_details != null">
	          		<template v-if="tx.payment_details.customer_bank_name != null">
		              <div class="col-6 mb-1" v-if="tx.payments.total_deposit != 0">
		                <p class="mb-1 body-2-2">{{$t("hotel.payment-method.bank-name")}}</p>
		              </div>
		              <div class="col-6 mb-1" v-if="tx.payments.total_deposit != 0">
		                <p class="mb-1 body-2-2">: {{$t("payment-gateway."+tx.payment_details.customer_bank_name)}}</p>
		              </div>
		            </template>
	              <div class="col-6 mb-1" v-if="tx.payments.total_deposit != 0">
	                <p class="mb-1 body-2-2">{{$t("general.payment-method")}}</p>
	              </div>
	              <div class="col-6 mb-1" v-if="tx.payments.total_deposit != 0">
	                <p class="mb-1 body-2-2">: {{tx.payment_details.payment_method_name}}</p>
	              </div>
	              <div class="col-6 mb-1" v-if="tx.payments.total_deposit != 0">
	                <p class="mb-1 body-2-2">{{$t("hotel.payment-method.status")}}</p>
	              </div>
	              <div class="col-6 mb-1" v-if="tx.payments.total_deposit != 0">
	                <p class="mb-1 body-2-2 font-bold text-green">: {{tx.status}}</p>
	              </div>
	            </template>
	            <div class="col-6 mb-1">
	              <p class="mb-1 body-2-2 font-regular">{{$t("hotel.success.room-charges")}}</p>
	            </div>
	            <div class="col-6 mb-1">
	              <p class="mb-1 body-2-2 font-regular">: {{$formatCurrency(tx.payments.total_payment - tx.payments.total_additional)}}</p>
	            </div>
	            <div class="col-6 mb-1" v-if="tx.payments.total_additional > 0">
	              <p class="mb-1 body-2-2 font-regular">{{$t("hotel.additional-service")}}</p>
	            </div>
	            <div class="col-6 mb-1" v-if="tx.payments.total_additional > 0">
	              <p class="mb-1 body-2-2 font-regular">: {{$formatCurrency(tx.payments.total_additional)}}</p>
	            </div>
	            <div class="col-6 mb-1 border-top pt-2">
	              <p class="mb-1 body-2-2 font-bold">{{$t("hotel.total")}}</p>
	            </div>
	            <div class="col-6 mb-1 border-top pt-2">
	              <p class="mb-1 body-2-2 font-bold">: {{$formatCurrency(tx.payments.total_payment)}}</p>
	            </div>
	            <div class="col-6 mb-1">
	              <p class="mb-2 body-2-2" :class="{'font-bold': tx.payments.payment_surcharge == 0}">{{ this.$isNotEmptyV2(getMerchant.booking_engine_cart_payable_deposit_label) ? getMerchant.booking_engine_cart_payable_deposit_label : $t('hotel.deposit-due-now')}}</p>
	            </div>
	            <div class="col-6 mb-1">
	              <p class="mb-2 body-2-2" :class="{'font-bold text-green': tx.payments.payment_surcharge == 0}">: {{$formatCurrency(roundUpIfXenditCC(tx.payments.total_deposit))}}</p>
	            </div>
	            <template v-if="tx.payments.payment_surcharge > 0">
	            	<div class="col-6 mb-1">
	                <p class="mb-2 body-2-2">{{$t("hotel.payment-surcharge")}}</p>
	              </div>
	              <div class="col-6 mb-1">
	                <p class="mb-2 body-2-2">: {{$formatCurrency(roundUpIfXenditCC(tx.payments.payment_surcharge))}}</p>
	              </div>
	              <div class="col-6 mb-1">
	                <p class="mb-2 body-2-2 font-bold">Total {{ this.$isNotEmptyV2(getMerchant.booking_engine_cart_payable_deposit_label) ? getMerchant.booking_engine_cart_payable_deposit_label : $t('hotel.deposit-due-now')}}</p>
	              </div>
	              <div class="col-6 mb-1">
	                <p class="mb-2 body-2-2 font-bold text-green">: {{$formatCurrency(roundUpIfXenditCC(tx.payments.total_deposit)+roundUpIfXenditCC(tx.payments.payment_surcharge))}}</p>
	              </div>
	            </template>
	            <div class="col-6 border-top pt-2" v-if="is_deposit_arrival">
	              <p class="mb-0 body-2-2 font-bold text-14">{{ this.$isNotEmptyV2(getMerchant.booking_engine_cart_payable_at_hotel_label) ? getMerchant.booking_engine_cart_payable_at_hotel_label : $t('hotel.deposit-due-on-arrival')}}</p>
	            </div>
	            <div class="col-6 border-top pt-2" v-if="is_deposit_arrival">
	              <p class="mb-0 body-2-2 font-bold text-16 text-orange">: {{$formatCurrency(tx.payments.total_payment - tx.payments.total_deposit)}}</p>
	            </div>
	          </div>
	        </div>
	    	</div>
	    </template>
    </popup-detail>
	</div>
</template>
<script>
	import {post} from '@/services/index.js'
	import {mapGetters} from 'vuex'

	export default{
		props: ['reason','tx'],
		data(){
			return{
				show_detail: false,
				flickityOptions: {
          initialIndex: 0,
          autoPlay: 3000,
          prevNextButtons: false,
          pageDots: false,
          adaptiveHeight: false,
          draggable: true,
          wrapAround: true,
        },
			}
		},
		computed:{
      ...mapGetters(['getMerchant']),
			is_valid_visitor(){
      	let display = false
      	if (this.tx.visitor_details.address != '' && this.tx.visitor_details.email != '' && this.tx.visitor_details.first_name != '' && this.tx.visitor_details.phone_number != '') {
      		display = true
      	}
      	return display
      },
      is_deposit_arrival(){
      	return this.tx.payments.total_payment - this.tx.payments.total_deposit > 0 ? true : false
      },
		},
		methods:{
			roundUpIfXenditCC(data){
      	let isNumber = Number(data)
      	if(Object.keys(this.tx).length > 0 && this.tx.payment_details.bank_name == 'XENDIT' && this.tx.payment_details.payment_method == 'CREDIT_CARD'){
      		return Math.ceil(isNumber)
      	}else{
      		return isNumber
      	}
      },
			toggleDetail(){
				this.show_detail = !this.show_detail
			},
			reject(){
				return new Promise((success,fail)=>{
					this.submit('tx-refute-cancel').then(res=>success(res)).catch(err=>fail(err))
				})
			},
			accept(){
				return new Promise((success,fail)=>{
					this.submit('tx-confirm-cancel').then(res=>success(res)).catch(err=>fail(err))
				})
			},
			submit(type){
				return new Promise((success,fail)=>{
					post("CORE_HOTEL",`${type}/${this.$route.params.tx_order_id}`).then(response=>{
						let res = response.data
						if(res.success){
							this.$emit("done")
							success(res.message)
						}else{
							fail(res.message)
						}
					})
				})
			}
		}
	}
</script>



// WEBPACK FOOTER //
// src/components/hotel/be/CancelBooking.vue